var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    {
      staticClass: "q-pa-none",
      staticStyle: {
        height: "100vh",
        display: "flex",
        "flex-direction": "column"
      }
    },
    [
      _c(
        "q-toolbar",
        { staticClass: "bg-primary text-white shadow-2 toolbar-no-pad" },
        [
          _c(
            "div",
            { staticClass: "row items-center" },
            [
              _c(
                "q-avatar",
                {
                  staticClass: "q-mr-sm bg-white text-primary",
                  attrs: { square: "", size: "36px" }
                },
                [
                  _c("q-icon", {
                    attrs: { name: "picture_as_pdf", size: "22px" }
                  })
                ],
                1
              ),
              _c(
                "q-toolbar-title",
                {
                  staticClass: "column q-mr-md q-pa-none",
                  staticStyle: {
                    "max-width": "350px",
                    overflow: "hidden",
                    "text-overflow": "ellipsis"
                  }
                },
                [
                  _c("div", { staticClass: "text-subtitle2 ellipsis" }, [
                    _vm._v(
                      "\n          Gestão Tributária - " +
                        _vm._s(_vm.nomeArquivo) +
                        "\n        "
                    )
                  ]),
                  _c("span", { staticStyle: { "font-size": "10px" } }, [
                    _vm._v(_vm._s(_vm.desLogin) + " - " + _vm._s(_vm.getNome()))
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-left": "auto",
                display: "flex",
                "align-items": "center",
                gap: "6px"
              }
            },
            [
              _c("q-btn", {
                attrs: {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "file_download",
                  color: "orange",
                  title: "Baixar " + _vm.nomeArquivo
                },
                on: { click: _vm.baixarPdf }
              }),
              _c("q-btn", {
                attrs: {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "print",
                  color: "orange",
                  title: "Imprimir PDF"
                },
                on: { click: _vm.imprimirPdf }
              }),
              _c("q-separator", {
                attrs: { vertical: "", color: "white", spaced: "" }
              }),
              _c("q-btn", {
                attrs: {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "zoom_in",
                  title: "Aumentar Zoom"
                },
                on: { click: _vm.aumentarZoom }
              }),
              _c("q-btn", {
                attrs: {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "zoom_out",
                  title: "Diminuir Zoom"
                },
                on: { click: _vm.diminuirZoom }
              }),
              _c("q-btn", {
                attrs: {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "fit_screen",
                  title: "Ajustar para tela"
                },
                on: { click: _vm.ajustarTamanhoTela }
              })
            ],
            1
          )
        ]
      ),
      _c("div", { staticStyle: { flex: "1", position: "relative" } }, [
        _c("iframe", {
          key: _vm.objExportacao.urlPdf,
          staticClass: "iframe",
          attrs: {
            id: "relatorios",
            src: this.objExportacao.urlPdf,
            width: "100%",
            height: "100vh",
            title: "Visualizador de Relatório em PDF"
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }